// @ts-nocheck
/**
 * ドラフトシステム - NPC性格定義
 */

export const NPC_PERSONALITIES = {
  // バランス型
  balanced: {
    id: 'balanced',
    name: 'バランサー・ベル',
    description: '安定したピックを好む堅実派',
    avatar: '🎭',
    priorityCurve: { lowCost: 0.3, midCost: 0.5, highCost: 0.2 },
    preferredTypes: null,
    preferredCategories: null,
    preferredAttributes: null,
    rarityWeight: 0.3,
    synergyWeight: 0.5,
    hateDraftChance: 0.1,
  },

  // アグロ型
  aggro: {
    id: 'aggro',
    name: 'ラッシュ・レオ',
    description: '低コストモンスターを好む速攻派',
    avatar: '🦁',
    priorityCurve: { lowCost: 0.5, midCost: 0.4, highCost: 0.1 },
    preferredTypes: ['monster'],
    preferredCategories: ['ドラゴン', 'ビースト'],
    preferredAttributes: null,
    rarityWeight: 0.2,
    synergyWeight: 0.4,
    hateDraftChance: 0.05,
  },

  // コントロール型
  control: {
    id: 'control',
    name: 'セイバー・シルヴィア',
    description: '魔法とフィールドカードを重視する戦略家',
    avatar: '🗡️',
    priorityCurve: { lowCost: 0.2, midCost: 0.4, highCost: 0.4 },
    preferredTypes: ['magic', 'field'],
    preferredCategories: null,
    preferredAttributes: null,
    rarityWeight: 0.4,
    synergyWeight: 0.6,
    hateDraftChance: 0.2,
  },

  // 炎属性特化
  fire_focused: {
    id: 'fire_focused',
    name: 'フレイム・フィオナ',
    description: '炎属性に特化した専門家',
    avatar: '🔥',
    priorityCurve: { lowCost: 0.3, midCost: 0.4, highCost: 0.3 },
    preferredTypes: null,
    preferredCategories: ['ドラゴン', 'ワイバーン'],
    preferredAttributes: ['炎'],
    rarityWeight: 0.3,
    synergyWeight: 0.7,
    hateDraftChance: 0.15,
  },

  // 水属性特化
  water_focused: {
    id: 'water_focused',
    name: 'アクア・アリス',
    description: '水属性と状態異常を操る',
    avatar: '💧',
    priorityCurve: { lowCost: 0.25, midCost: 0.5, highCost: 0.25 },
    preferredTypes: null,
    preferredCategories: ['タイドウェーブ', 'スネーク'],
    preferredAttributes: ['水'],
    rarityWeight: 0.35,
    synergyWeight: 0.6,
    hateDraftChance: 0.1,
  },

  // 闇属性特化（ハイリスク）
  dark_focused: {
    id: 'dark_focused',
    name: 'ダーク・ディアナ',
    description: 'ハイリスク・ハイリターンを好む',
    avatar: '🌙',
    priorityCurve: { lowCost: 0.15, midCost: 0.35, highCost: 0.5 },
    preferredTypes: null,
    preferredCategories: null,
    preferredAttributes: ['闇'],
    rarityWeight: 0.5,
    synergyWeight: 0.3,
    hateDraftChance: 0.25,
  },

  // 原始属性特化（展開型）
  primitive_focused: {
    id: 'primitive_focused',
    name: 'プリミティブ・ポール',
    description: '粘液獣など展開系を好む',
    avatar: '🌿',
    priorityCurve: { lowCost: 0.4, midCost: 0.45, highCost: 0.15 },
    preferredTypes: null,
    preferredCategories: ['スライム', 'プラント', 'ビースト'],
    preferredAttributes: ['原始'],
    rarityWeight: 0.2,
    synergyWeight: 0.8,
    hateDraftChance: 0.05,
  },
};

// レアリティスコア
export const RARITY_SCORES = {
  C: 10,
  UC: 20,
  R: 40,
  SR: 70,
  UR: 100,
  HR: 150,
  SEC: 200,
  ALT: 250,
  SP: 300,
  GR: 400,
};

/**
 * 人数に応じたNPCリストを取得
 * @param {number} playerCount - 参加人数（プレイヤー含む）
 * @returns {Array} NPC性格IDの配列
 */
export const getNPCsForPlayerCount = (playerCount) => {
  const allNPCs = [
    'balanced',
    'aggro',
    'control',
    'fire_focused',
    'water_focused',
    'dark_focused',
    'primitive_focused',
  ];

  // プレイヤー1人分を除いたNPC数
  const npcCount = playerCount - 1;

  // シャッフルして必要数を返す
  const shuffled = [...allNPCs].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, npcCount);
};

/**
 * NPC情報を取得
 * @param {string} personalityId - 性格ID
 * @returns {Object} NPC情報
 */
export const getNPCInfo = (personalityId) => {
  return NPC_PERSONALITIES[personalityId] || NPC_PERSONALITIES.balanced;
};

export default NPC_PERSONALITIES;
